import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../base.service';

export const PlannerApi = createApi({
  reducerPath: 'PlannerService',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Planner', 'Dashboard', 'Label', 'Comment', 'Task'],
  endpoints: () => ({}),
});
